import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { QueryListFilter } from '@feedyou/schema'
import { not, appendQueryParamsToUrl } from '@feedyou/utils'

import { allQueryFilterKeys } from '../utils'
import { includeString } from '../../../lib/string'

export function useCommitQueryFilterToUrlQuery(params?: {
  omitQueryFilterKeys?: (keyof QueryListFilter)[]
  invalidateTags: () => void
}) {
  const history = useHistory()
  const dispatch = useDispatch()

  const { invalidateTags, omitQueryFilterKeys = [] } = params || {}
  const queryFilterKeys = allQueryFilterKeys().filter(not(includeString(omitQueryFilterKeys)))

  function commitFilterToUrlQuery(filter: QueryListFilter) {
    const urlPath = history.location.pathname + history.location.search
    const queryParams = queryFilterKeys.map(key => ({
      [key]: filter[key]?.toString() || undefined
    }))

    history.push(appendQueryParamsToUrl(urlPath, { ...Object.assign({}, ...queryParams) }))
    dispatch(invalidateTags?.()) // force re-fetch to ensure we get the latest data
  }

  return useCallback(commitFilterToUrlQuery, [history, queryFilterKeys, dispatch, invalidateTags])
}
